import { createAction } from "redux-actions";
import {
  BOOKING_SUCCESS_POPUP_FEEDBACK_UPDATE,
  CREATE_VISITOR_POPUP_UPDATE,
  UPDATE_VISITOR_POPUP_UPDATE,
  UPDATE_MAP_LOADING_STATUS,
  ADD_FLAT_POPUP_UPDATE,
  ADD_FAMILY_MEMBER_POPUP_UPDATE,
  IMAGE_VIEWER_UPDATE,
  VEHICLE_DETAIL_POPUP_UPDATE,
  FEEDBACK_POPUP_UPDATE,
  RESET_LAYOUT,
  UPDATE_LOCATION_REQUEST,
  UPDATE_LOCATION_RESPONSE,
  UPDATE_LAST_LOCATION_RESPONSE,
} from "./types";

export const bookingSuccessPopupFeedbackUpdate = createAction(
  BOOKING_SUCCESS_POPUP_FEEDBACK_UPDATE
);
export const createVisitorPopupUpdate = createAction(
  CREATE_VISITOR_POPUP_UPDATE
);
export const updateVisitorPopupUpdate = createAction(
  UPDATE_VISITOR_POPUP_UPDATE
);
export const updateMapLoadingStatus = createAction(UPDATE_MAP_LOADING_STATUS);
export const updateAddFlatPopupUpdate = createAction(ADD_FLAT_POPUP_UPDATE);
export const updateAddFamilyMemberPopup = createAction(
  ADD_FAMILY_MEMBER_POPUP_UPDATE
);
export const imageViewerUpdate = createAction(IMAGE_VIEWER_UPDATE);
export const vehicleDetailPopupUpdate = createAction(
  VEHICLE_DETAIL_POPUP_UPDATE
);
export const feedbackPopupUpdate = createAction(FEEDBACK_POPUP_UPDATE);
export const resetLayout = createAction(RESET_LAYOUT);
export const updateLocationRequest = createAction(UPDATE_LOCATION_REQUEST);
export const updateLocationResponse = createAction(UPDATE_LOCATION_RESPONSE);
export const updateLastLocationResponse = createAction(
  UPDATE_LAST_LOCATION_RESPONSE
);
